<script setup>
import {ref} from "vue";
import {usePage} from "@inertiajs/vue3";

const props = defineProps({
  name: String
})

const reversed = ref(false)
</script>

<template>
  <div id="impersonate-container" class="d-print-none" :class="{'reversed': reversed}" v-on:dblclick="reversed = !reversed">
    <p v-html="trans('dashboard.impersonating_as_x', {name})"/>
    <inertia-link :href="route('dashboard.impersonate.stop')" method="post" v-text="trans('dashboard.stop_impersonating')"/>
  </div>
</template>

<style scoped lang="scss">
#impersonate-container {
  position: fixed;
  padding: 15px 20px 15px 15px;
  min-width: 160px;
  top: 35%;
  right: -5px;
  color: black;
  background-color: #fff;
  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .05);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .05);
  border-radius: .5rem;
  text-align: center;
  z-index: 9999;
  user-select: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  &.reversed {
    top: 75%;
  }

  a {
    text-decoration: underline;
    color: black;
    font-weight: bold
  }
}
</style>
